module.exports = __webpack_public_path__ + "static/media/HO10.0b749943.png";